import { Dialog, DialogContent, DialogDescription, DialogHeader, ScrollArea } from 'alm-react-components';

import remindersIconImg from "../../assets/images/svgicons/reminders-icon.svg";

type DailyReminderProps = {
    fullText:boolean
    setFullText:(val:boolean)=>void
    text:string
  };

const DailyReminderModal = ({fullText,setFullText,text}:DailyReminderProps) => {
  return (
    <Dialog open={fullText} onOpenChange={setFullText}>
        <DialogContent className="w-auto dark:card-gradient-gray dark:text-whitemin-w-72 reminders-dialog" >
          <DialogHeader>
            <ScrollArea className=" max-h-[calc(100vh-165px)]">
              <DialogDescription className="text-white tracking-wide" >
                <div className=" justify-center flex mb-3">
                  <img src={remindersIconImg} alt={" "} className="logo text-sm w-[23px] h-[18px]"  />
                </div>
                <div className=" justify-center flex mb-3">
                  </div>
                  <p  className="text-base font-barlowLight text-primary pb-3 text-center break-words select-none">
                    {text}
                  </p>
              </DialogDescription>
            </ScrollArea>
          </DialogHeader>
        </DialogContent>
      </Dialog>
  )
}

export default DailyReminderModal